import React from 'react';
import { Modal, Input, Select, notification } from 'antd';
import { post } from '../../utils/http'
import api from '../../utils/api'

const { Option } = Select;
const { confirm } = Modal;

export default function CreateNewMenu(props) {
    let p = props.editValue.controlPermission == null || props.editValue.controlPermission ?[]:props.editValue.controlPermission.split(",")
    const [menuname, setMenuname] = React.useState(props.editValue.menuName);
    const [path, setPath] = React.useState(props.editValue.menuPath);
    const [component, setComponent] = React.useState(props.editValue.component);
    const [permission, setPermission] = React.useState(p);
    const [menuIcon, setMenuIcon] = React.useState(props.editValue.menuIcon);
    const [parentId, setParentId] = React.useState(props.editValue.parentId);
    const [confirmLoading, setConfirmLoading] = React.useState(false);

    const handleSubmit = () => {//submit button
        setConfirmLoading(true)
        var ps = permission.join(",")
        const editData = {
            menuId:props.editValue.menuId,
            menuName: menuname,
            menuPath: path,
            component: component,
            controlPermission: ps,
            menuIcon: menuIcon,
            parentId: parentId,
        }
        post(api.saveAndUpdateMenu, editData).then(function (response) {

            notification['success']({
                message: 'Update successfully.',
            });
            props.closeEditModal();
            props.handleSearch();
            setConfirmLoading(false)
        }).catch(function (error) {
            notification['error']({
                message: 'Fail to update.',
            });
            Modal.destroyAll();
            props.closeEditModal();
            setConfirmLoading(false)
            console.log("@error", error)
        })

        props.closeEditModal()
    }

    const handleCancle = () => {
        confirm({
            content: "Are you sure to close this modal?",
            onOk() {
                Modal.destroyAll();
                props.closeEditModal();
            }
        });
    };

    return (
        <>
            <Modal
                title="Edit Menu"
                visible={props.isOpenEdit}
                onOk={handleSubmit}
                confirmLoading={confirmLoading}
                onCancel={handleCancle}
            >
                <div style={{ display: "flex" }}>
                    <p style={{ width: "110px", lineHeight: "36px" }}>Menuname </p>
                    <Input value={menuname} placeholder="menuName" onChange={event => setMenuname(event.target.value)} style={{ height: "36px", width: "350px" }} />
                </div>

                <div style={{ display: "flex" }}>
                    <p style={{ width: "110px", lineHeight: "36px" }}>Path </p>
                    <Input value={path} placeholder="path" onChange={event => setPath(event.target.value)} style={{ height: "36px", width: "350px" }} />
                </div>

                <div style={{ display: "flex" }}>
                    <p style={{ width: "110px", lineHeight: "36px" }}>Component </p>
                    <Input value={component} placeholder="conponent" onChange={event => setComponent(event.target.value)} style={{ height: "36px", width: "350px" }} />
                </div>

                <div style={{ display: "flex" }}>
                    <p style={{ width: "110px", lineHeight: "36px" }}>Permissions </p>
                    <Select
                        value={permission}
                        mode="multiple"
                        placeholder="permissions"
                        allowClear={true}
                        onChange={value => setPermission(value)}
                        style={{ height: "36px", width: "350px" }}
                    >
                        <Option key={"EDIT_BTN"}>EDIT_BTN</Option>
                        <Option key={"CREATE_BTN"}>CREATE_BTN</Option>
                        <Option key={"SEARCH_BTN"}>SEARCH_BTN</Option>
                        <Option key={"DELETE_BTN"}>DELETE_BTN</Option>
                    </Select>
                </div>

                <div style={{ display: "flex" }}>
                    <p style={{ width: "110px", lineHeight: "36px" }}>MenuIcon</p>
                    <Input value={menuIcon} placeholder="menu icon" onChange={event => setMenuIcon(event.target.value)} style={{ height: "36px", width: "350px" }} />
                </div>

                <div style={{ display: "flex" }}>
                    <p style={{ width: "110px", lineHeight: "36px" }}>Perant </p>
                    <Select
                        value={parentId}
                        placeholder="perant"
                        onChange={value => setParentId(value)}
                        style={{ height: "36px", width: "350px" }}
                    >
                        <Option value={0}> </Option>
                        <Option value={1}>Home</Option>
                        <Option value={2}>User Management</Option>
                        <Option value={3}>Balance & Transactions</Option>
                        <Option value={4}>Counter Management</Option>
                        <Option value={5}>Settings</Option>
                        <Option value={6}>Service</Option>
                    </Select>
                </div>

            </Modal>
        </>
    );
}